import { useLLMConversations } from '@ltvco/refresh-lib/hooks';
import { Box } from '@ltvco/refresh-lib/theme';
import { useNavigate, useParams } from 'react-router-dom';

import {
  StyledConversationList,
  StyledConversationListItem,
  StyledConversationListItemText,
} from './components';

export const ConversationList = ({
  collapsed,
  fullWidth: _fullWidth,
  onConversationClick,
}: {
  collapsed: boolean;
  fullWidth?: boolean;
  onConversationClick?: () => void;
}) => {
  const { conversationsQuery } = useLLMConversations();
  const params = useParams();
  const currentContextId = params.context_id || params.contextId;

  const chatList = conversationsQuery.data?.conversations;
  const navigate = useNavigate();

  const handleConversationClick = (context_id: string) => {
    navigate(`/chatbv/chat/conversation/${context_id}`);
    onConversationClick?.();
  };

  return (
    <StyledConversationList
      collapsed={collapsed}
      spacing={2}
      style={{
        width: '100%',
        height: '100%',
        padding: 0,
      }}
      alignItems="flex-start"
    >
      <Box
        sx={{
          width: '100%',
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {chatList?.map((conversation) => {
          const isActive = conversation.context_id === currentContextId;
          return (
            <StyledConversationListItem
              isActive={isActive}
              key={conversation.context_id}
              onClick={() => handleConversationClick(conversation.context_id)}
            >
              <StyledConversationListItemText
                variant="body2"
                isActive={isActive}
              >
                {(
                  conversation.conversation_title ??
                  'Start of a new conversation'
                ).replace('**User prompt:**', '')}
              </StyledConversationListItemText>
            </StyledConversationListItem>
          );
        })}
      </Box>
    </StyledConversationList>
  );
};
